module.exports = __webpack_public_path__ + "labioplastika_10_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_10_after.jpg
// module id = 1063
// module chunks = 0